import Vue from 'vue'
import * as types from 'store/mutation-types'

function filterItems(data, id) {
  return data.filter(item => item.id === id)[0]
}

function normalizeSimpleObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: null
  }
  if (object.items) {
    standardObj.items = [...object.items]
  } else if (object.data) {
    standardObj.items = [...object.data]
  }
  return standardObj
}

function normalizeSpecialAdvisorObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    date: object.date,
    name: object.name,
    items: null
  }
  if (object.items) {
    standardObj.items = [...object.items]
  } else if (object.data) {
    standardObj.items = [...object.data]
  }
  return standardObj
}

const actions = {
  loadCnTodayDiscovery({ commit, getters }, { market, category }) {
    const param = getters.discoveryFilter
    const unusualList = () =>
      Vue.http
        .get('~stock/astock/explore/unusual', {
          params: { limit: 50, ...param.aConnectFilter }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })
    const hotList = () =>
      Vue.http
        .get('~stock/astock/explore/hot', {
          params: { limit: 50 }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })

    return Promise.all([unusualList(), hotList()]).then(([unusual, hot]) => {
      const watchlistTop = filterItems(hot.items, 'watchlistTop')
      const volumeShTop = filterItems(hot.items, 'volumeShTop')
      const volumeSzTop = filterItems(hot.items, 'volumeSzTop')
      const changeRate5MinTop = filterItems(unusual.items, 'changeRate5MinTop')
      const changeRate5MinDrop = filterItems(
        unusual.items,
        'changeRate5MinDrop'
      )
      const amplitudeTop = filterItems(unusual.items, 'amplitudeTop')
      const turnoverTop = filterItems(unusual.items, 'turnoverTop')
      const payload = {
        market,
        category,
        watchlistTop: normalizeSimpleObject(watchlistTop),
        volumeShTop: normalizeSimpleObject(volumeShTop),
        volumeSzTop: normalizeSimpleObject(volumeSzTop),
        changeRate5MinTop: normalizeSimpleObject(changeRate5MinTop),
        changeRate5MinDrop: normalizeSimpleObject(changeRate5MinDrop),
        amplitudeTop: normalizeSimpleObject(amplitudeTop),
        turnoverTop: normalizeSimpleObject(turnoverTop)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  },
  loadCnSpecialDiscovery({ commit }, { market, category }) {
    const crossExchange = () =>
      Vue.http
        .get('~stock/astock/ranking/crossExchangeTop', {
          params: { limit: 50 }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })

    const advisor = typeId =>
      Vue.http
        .get('~tcti/advisor/board', {
          params: { type: typeId, market: 'CN', pageSize: 50 }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data.data
          }
        })

    return Promise.all([
      crossExchange('crossExchangeTop'),
      advisor('alligator'),
      advisor('bollList'),
      advisor('kdjList'),
      advisor('rsiList')
    ]).then(([crossExchange, alligator, boll, kdj, rsi]) => {
      const cnBuy = filterItems(alligator, 'cnBuy')
      const cnSell = filterItems(alligator, 'cnSell')
      const payload = {
        market,
        category,
        crossExchange: normalizeSimpleObject(crossExchange),
        cnSell: normalizeSpecialAdvisorObject(cnSell),
        cnBuy: normalizeSpecialAdvisorObject(cnBuy),
        boll: normalizeSpecialAdvisorObject(boll),
        kdj: normalizeSpecialAdvisorObject(kdj),
        rsi: normalizeSpecialAdvisorObject(rsi)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  }
}

export default {
  actions
}
